import DrawerSectionHeading from 'components/DrawerSectionHeading';
import DefinitionTooltip from 'components/DefinitionTooltip';
import { TikTokIcon } from 'components/Icons';
import TopPhrasesSection from 'components/TopKeywordsSection/TopPhrasesSection';
import { downloadItemsAsCSV } from 'utils/formatCSV';
import { tooltips } from '@/copy';
import useFlavorHashtags from './useFlavorHashtags';
import useTikTokWeeks from 'utils/hooks/useTikTokWeeks';

function HashtagsWrapper(props) {
    return <div {...props} />;
}

function HashtagsHeading({ children, showIcon, data }) {
    return (
        <DrawerSectionHeading className="my-6">
            <span css="display: flex; align-items: center; gap: .5rem;">
                {showIcon ? <TikTokIcon /> : null}
                Hashtags
                <DefinitionTooltip
                    {...tooltips.hashtags}
                    week={data?.week}
                    year={data?.year}
                    mixpanelMeta={{ contentKey: 'hashtags' }}
                    openOnClick={true}
                />
            </span>
            {children}
        </DrawerSectionHeading>
    );
}

function NoHashtags() {
    return (
        <div
            css={`
                color: ${({ theme }) => theme.neutral_3};
            `}
        >
            No hashtags to show.
        </div>
    );
}

const hashtagCSVColumns = [
    { key: 'kw', label: 'hashtag' },
    { key: 'volume', label: 'views' },
];

function FlavorHashtagsDrawer({ country, category, flavor, filename }) {
    const { year, week } = useTikTokWeeks();
    const hashtagsQuery = useFlavorHashtags({
        country: country ? [country] : null,
        category: category ? [category] : null,
        flavor: flavor ? [flavor] : null,
        enabled: Boolean(country && category && flavor),
    });
    const sortedData =
        hashtagsQuery.data?.data?.map(({ id, hashtag, views }) => ({
            id,
            kw: hashtag,
            volume: views,
        })) || null;
    const handleDownload = () =>
        downloadItemsAsCSV(filename, sortedData, hashtagCSVColumns);
    const mixpanelMeta = { contentKey: 'TopHashtags' };

    return (
        <TopPhrasesSection
            data={{ country, category, flavor, year, week }}
            isLoading={hashtagsQuery.isLoading}
            sortedData={sortedData}
            dataReady={!!sortedData?.length}
            showTranslations={false}
            handleDownload={handleDownload}
            mixpanelMeta={mixpanelMeta}
            paginateBy="hashtags"
            HeadingComponent={HashtagsHeading}
            WrapperComponent={HashtagsWrapper}
            NoDataComponent={NoHashtags}
        />
    );
}

export default FlavorHashtagsDrawer;
